// Training: the list its address can open. No React in here.
//
// The dashboard is read-only: attendance is marked in Grow › Offline Trainings, which
// the dashboard offers under "Related" (navigation/catalog) to someone who holds it.
import type { DashboardListInfo } from './types';

/** The slug the home screen links to: invitations to sessions that have started, with no attendance entered. */
export const NOT_MARKED_SLUG = 'not-marked';

/** Every list on Training that can be opened by address. */
export const LISTS: DashboardListInfo[] = [
  {
    slug: NOT_MARKED_SLUG,
    name: 'Not marked',
    // "Have started", not "already held": the server counts a session from its start time.
    line: 'Invitations to sessions that have started in the month, where nobody has recorded whether the person attended.',
    keywords: 'attendance not marked unmarked pending',
  },
];
